import * as React from 'react';
import './tooltip.css'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

 const CustomTooltip =({displatText} : any) => {
  return (
    <div className="tooltip"> 
        <InfoOutlinedIcon color="primary"></InfoOutlinedIcon>
        <span className="tooltiptext">{displatText}</span>
    </div>
    
  );
}
export default CustomTooltip